module.exports = __webpack_public_path__ + "static/media/happy-birthday-cake-2020.efaf607f.jpg";